import { useLanguage } from "../i18n/LanguageContext";
import { useEffect } from "react";

const About = () => {
  const { t } = useLanguage();
  useEffect(() => {
    // Set page keywords
    document.querySelector('meta[name="keywords"]').setAttribute(
      "content",
      `full-stack developer, software developer, software engineer, computer engineer, software developer in Kuwait,Kuwait, 
      Coded Academy, AUM, Ruby on Rails, Ruby, React, JavaScript, TypeScript, Nextjs, HTML, CSS, website, application, 
      Marissa Mayer, about us`,
    );
  }, []);

  return (
    <div id="about" className="about">
      <div className="about-content">
        <h1>{t("nav.about")}</h1>
        <div className="about-columns">
          <div className="about-story">
            <p className="about-introduction">{t("about.introduction")}</p>
            <p>{t("about.education")}</p>
            <p>{t("about.journey")}</p>
          </div>
          <aside className="about-inspiration">
            <p className="about-inspiration-label">{t("about.inspiration")}</p>
            <figure className="about-quote">
              <span className="about-quote-mark" aria-hidden="true">
                ❝
              </span>
              <blockquote>
                <p>{t("about.quote")}</p>
              </blockquote>
              <figcaption>{t("about.quoteAuthor")}</figcaption>
            </figure>
            <div className="about-puzzle">
              <p>{t("about.puzzleHint")}</p>
              <p>{t("about.puzzlePrompt")}</p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default About;
